import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DatepickerRange, MultiselectItem, TableState } from '@ui/aos-lib';
import { DeviceHealthPresentation } from 'src/app/pages/equipment/devices/components/device-details/device-details-metrics/device-details-metrics.types';
import { TableData } from 'src/app/shared/types/api-response.types';
import { ReportGroupFilterResponse } from 'src/app/services/api/report-group-filter/report-group-filter-api.types';
import { WidgetConfig } from '../../components/consumption-widget/consumption-widget.interface';
import { ConsumptionReads, UnitOfMeasureModelConsumptionAnalytics } from '../../shared/consumption.types';
import { UserConfigTotalConsumptionFilters } from '../consumption-analytics.types';
import { FlowDirection } from '@portal/shared/types/filter.types';
import { GetTableDataItem } from 'src/app/pages/equipment/devices/components/device-details/device-details-metrics/meter/meter-consumption-tab-content/meter-consumption-tab-content.types';

export const ConsumptionAnalyticsActions = createActionGroup({
  source: 'Consumption Analytics',
  events: {
    'Get Widget Consumptions': props<{ selectedUom?: string }>(),
    'Get Widget Consumptions Success': props<{ widget: WidgetConfig }>(),
    'Get Widget Consumptions Failure': props<{ error: string }>(),

    'Set Filters': props<{
      reportGroupUID?: string;
      dateRange?: DatepickerRange;
      previousPeriod?: MultiselectItem;
      flowDirection?: FlowDirection[];
    }>(),
    'Update Selected Report Group': props<{ reportGroup: MultiselectItem }>(),

    'Get Consumptions': emptyProps(),
    'Get Consumptions Success': props<{ consumptions: DeviceHealthPresentation[] }>(),
    'Get Consumptions Failure': props<{ error: string }>(),

    'Refresh Data': emptyProps(),

    'Get Consumption Reads': emptyProps(),
    'Get Consumptions Reads Success': props<{ consumptionReads: TableData<ConsumptionReads> }>(),
    'Get Consumptions Reads Failure': props<{ error: string }>(),

    'Set Table State': props<{ tableState: TableState }>(),
    'Set Unit Of Measure Model': props<{ model: UnitOfMeasureModelConsumptionAnalytics; reportGroupUID?: string }>(),

    'Build Widget With Uom': emptyProps(),
    'Build Chart With Uom': emptyProps(),
    'Build Table With Uom': emptyProps(),
    'Build Entities With Uom': emptyProps(),

    'Set Chart Numbers Shown': props<{ isShown: boolean }>(),
    'Clear Consumption': emptyProps(),

    'Get Report Group And Init Filters State': props<{
      filtersState: UserConfigTotalConsumptionFilters | null;
      pageSize?: number | null;
    }>(),
    'Init Filters': props<{
      reportGroups: ReportGroupFilterResponse[];
      filtersState: UserConfigTotalConsumptionFilters | null;
      dateRange: DatepickerRange;
      restoredTake?: number;
    }>(),

    'Get Persisted Filters State': emptyProps(),
    'Save Persisted Filters State': emptyProps(),
    'Save Persisted Filters State Success': emptyProps(),
    'Save Persisted Filters State Failure': props<{ error: string }>(),

    'Get Consumptions Electric': emptyProps(),
    'Get Consumptions Electric Success': props<{ consumptions: DeviceHealthPresentation[] }>(),
    'Get Consumptions Electric Failure': props<{ error: string }>(),
    'Get Consumption Reads Electric': emptyProps(),
    'Get Consumptions Reads Electric Success': props<{ consumptionReads: TableData<GetTableDataItem> }>(),
    'Get Consumptions Reads Electric Failure': props<{ error: string }>()
  }
});
